<script>
	// Stores 
	import { 
		mailAtendimento,
	} from '../store.js';    

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from "../components/PageHeader.svelte";
	import Forms from "../components/Forms.svelte";

	// Code
	let titlePage = 'Débito em Conta';

	let fields = [
		{
			title: 'Tipo de Vínculo *',
			name: 'vinculo',
			type: 'select',
			required:   'required',
			selectValues: [
				{
					title: 'Condômino',
					value: 'Condômino'
				},
				{
					title: 'Locatário',
					value: 'Locatário'
				}
			]
		},	
		{
			title:      'Seu nome *',
			name:       'nome',
			required:   'required'
		},
		{
			title:      'Telefone *',
			name:       'telefone',
			required:   'required',
			classe:     'mask-telefone'
		},
		{
			title:      'Email *',
			name:       'email',
			required:   'required',
			type:       'email'
		},
		{
			title:      'CPF *',
			name:       'cpf',
			required:   'required',
			classe:		'mask-cpf',
		},
		{
			title:      'Data de Nascimento *',
			name:       'datanasc',
			required:   'required',
			classe:		'mask-data',
		},
		{
			title:      'Endereço *',
			name:       'endereco',
			required:   'required'
		},
		{
			title:      'Banco *',
			name:       'banco',
			required:   'required'
		},
		{
			title:      'Agência *',
			name:       'agencia',
			required:   'required'
		},
		{
			title:      'Conta *',
			name:       'conta',
			required:   'required'
		},
	];      
	
	const message = `
Tipo de Vínculo: {vinculo}
Seu nome: {nome}
Telefone: {telefone}
Email: {email}
CPF: {cpf}
Data de Nascimento: {datanasc}
Endereço: {endereco}
Banco: {banco}
Agência: {agencia}
Conta: {conta}

{info}`;

	let loading = false;
	function send() {
		loading = true;
	}
</script>

<PageHeader title={titlePage} buttons="">
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<p>Cliente Bona Imóveis conta com uma série de facilidades! Com o débito em conta você economiza tempo e dinheiro. Envie seus dados que entraremos em contato.</p>
		</div>
	</div>
</PageHeader>


<div class="container">
	<p class="text-center">Bancos conveniados: Banco do Brasil, Banrisul, Bradesco, Itaú e Santander.</p>
	<div class="offset-md-3 col-md-6 pl-0 pr-0">        
		<hr class="line-separator">
		<Forms fields={fields} destiny={$mailAtendimento} subjectTitle="{titlePage}" {message} htmlbody={false} />
	</div>
</div>